import {
  Box,
  Grid,
  Typography,
  TextField,
  Link,
} from "@mui/material";
import styles from "../../Candidates/Candidate.module.css";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { PiMapPinSimpleLineLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { IoIosAdd } from "react-icons/io";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { addPreviousExperience } from "../../../redux/InternalStatic/internalCandidateStatic";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const AddCandidateExperiencess = () => {
  const [showMore, setShowMore] = useState(false);
  const [formFields, setFormFields] = useState([
    {
      role: "",
      company: "",
      industry_of_the_company: "",
      duration_from: "",
      duration_to: "",
      summary_of_work: "",
    },
  ]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { formik2 } = location?.state || {};
  const { prevData2 } = location.state || {};
  const { prevData1 } = location.state || {};
  const { prevData3 } = location.state || {};
  const { prevData } = location.state || {};
  const { resumeData } = location.state || {};
  const { selectedFileName } = location?.state || {};

  const handleOnClickSubmit = () => {
    dispatch(addPreviousExperience(formFields));
  };

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  useEffect(() => {
    if (resumeData || prevData2) {
      if (prevData2 === undefined || prevData2 === null || prevData2 === "") {
        setFormFields(resumeData?.data?.processed_json?.companies);
      } else if (prevData2?.length > 0) {
        setFormFields(prevData2);
      }
    }
  }, [resumeData, prevData2]);

  const handleAddFields = () => {
    setFormFields([
      ...formFields,
      {
        role: "",
        company: "",
        industry_of_the_company: "",
        duration_to: "",
        duration_from: "",
        summary_of_work: "",
      },
    ]);
  };

  const handleInputChange = (index, event) => {
    const values = [...formFields];
    values[index][event.target.name] = event.target.value;
    setFormFields(values);
  };

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(allLocation());
  }, []);

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  return (
    <Box className={styles.add_structure}>
      <Typography className={styles.add_heading}>
        <b>Professional Experiences</b>
      </Typography>

      {formFields?.map((field, index) => (
        <form onSubmit={(e) => e.preventDefault()}>
          <Grid
            container
            key={index}
            className={styles.candidate_field_section}
            sx={{ backgroundColor: "#fff" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Role"
                variant="standard"
                name="role"
                sx={fieldStyle}
                value={field.role}
                onChange={(event) => handleInputChange(index, event)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box
                className={styles.icon_style}
                sx={{ transform: "translateY(-50%) !important" }}
              >
                <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Organization"
                variant="standard"
                type="text"
                name="company"
                sx={fieldStyle}
                value={field.company}
                onChange={(event) => handleInputChange(index, event)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Domain"
                variant="standard"
                type="text"
                name="industry_of_the_company"
                sx={fieldStyle}
                value={field.industry_of_the_company}
                onChange={(event) => handleInputChange(index, event)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Duration From"
                variant="standard"
                type="text"
                name="duration_from"
                sx={fieldStyle}
                value={field.duration_from}
                onChange={(event) => handleInputChange(index, event)}
              />
            </Grid>
            {index !== 0 && (
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Duration To"
                  variant="standard"
                  type="text"
                  name="duration_to"
                  sx={fieldStyle}
                  value={field.duration_to}
                  onChange={(event) => handleInputChange(index, event)}
                />
              </Grid>
            )}
          </Grid>

          <Box className={styles.add_section}>
            <Box>
              <Typography>
                <b> Responsibilities</b>{" "}
              </Typography>
            
              <Typography sx={{ marginBottom: "0 !important" }}>
                <textarea
                  className="form-control"
                  rows="2"
                  name="summary_of_work"
                  value={field.summary_of_work}
                  onChange={(event) => {
                    handleInputChange(index, event);
                    autoResize(event.target);
                  }}
                  onInput={(event) => autoResize(event.target)}
                  style={{
                    borderColor: "#1991e0",
                    overflow: "hidden",
                    resize: "none", // Prevent manual resizing
                  }}
                  ref={(el) => el && autoResize(el)} // Auto-resize on initial render
                ></textarea>
                <Link className={styles.view_show_link} onClick={handleToggle}>
                  <IoIosAdd
                    onClick={handleAddFields}
                    style={{
                      marginTop: "10px",
                      fontSize: "30px",
                      color: "#000",
                      backgroundColor: "#f2f2f2",
                      borderRadius: "3px",
                      marginLeft: "20px",
                    }}
                  />
                </Link>
              </Typography>
            </Box>
          </Box>

          <Grid
            item
            xs={12}
            md={0.6}
            sx={{
              display: "flex",
              alignItems: "center",
              paddingTop: "0 !important",
            }}
          ></Grid>
        </form>
      ))}

      <Box className={styles.add_candidate_btns}>
        <Box className={styles.add_back_btns}>
          <button
            onClick={() =>
              navigate("/add-consultant-resume", {
                state: {
                  prevData: prevData,
                  prevData1: prevData1 || formik2,
                  selectedFileName: selectedFileName,
                  prevData2: formFields || prevData2,
                  prevData3: prevData3,
                },
              })
            }
            style={{
              border: "1.5px solid #4285f4",
              marginRight: "10px",
              padding: "4.5px 10px ",
            }}
          >
            <IoIosArrowRoundBack
              style={{ fontSize: "25px", color: "#4285f4" }}
            />
          </button>
        </Box>
        <button
          onClick={handleOnClickSubmit}
          style={{
            backgroundColor: "#3856a6 ",
            padding: "5.5px 5px 5.5px 10px ",
          }}
        >
          Next Please{" "}
          <IoIosArrowRoundForward
            style={{ fontSize: "25px", marginLeft: "5px" }}
          />
        </button>
      </Box>
    </Box>
    // </RootComponents>
  );
};

export default AddCandidateExperiencess;
